import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrl } from 'app/constants/ApiUrls';
import { Subscription } from 'app/models/subscription';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private readonly _subscriptions: BehaviorSubject<Subscription[]> = new BehaviorSubject<Subscription[]>(null);
  public subscriptions$: Observable<any> = this._subscriptions.asObservable();

  constructor(private readonly _http: HttpClient) { }

  getSubscriptions(id: string): void {
   const url = `${ApiUrl.companies}/${id}/subscriptions`;
   this._http.get<Subscription[]>(url).subscribe(
     (data: Subscription[]) => {
       this._subscriptions.next(data);
     }
   );
 
  }
}
